module.exports = __webpack_public_path__ + "img/ac logo.551da0fd.png";